<template>
  <div
    class="modal fade"
    id="sessions-columns"
    tabindex="-1"
    aria-hidden="true"
  >
    <div
      class="modal-dialog modal-xl modal-dialog-centered modal-simple modal-upgrade-plan"
    >
      <div class="modal-content">
        <div class="modal-body">
          <button
            type="button"
            class="btn-close"
            data-bs-dismiss="modal"
            aria-label="Close"
          ></button>

          <div class="text-center">
            <h4 class="mb-4">{{ $t("online.sessions_columns") }}</h4>
          </div>

          <div class="card-body">
            <div class="row">
              <div class="col-xxl-3 col-md-4 col-6 mb-5">
                <div class="form-check custom-option custom-option-icon">
                  <label
                    class="form-check-label custom-option-content"
                    for="username"
                  >
                    <span class="custom-option-body">
                      <i class="ti ti-at"></i>
                      <span class="custom-option-title">
                        {{ $t("online.username") }}
                      </span>
                    </span>
                    <input
                      class="form-check-input"
                      type="checkbox"
                      v-model="columns.username.enabled"
                      @change="updateColumns"
                      id="username"
                    />
                  </label>
                </div>
              </div>

              <div class="col-xxl-3 col-md-4 col-6 mb-5">
                <div class="form-check custom-option custom-option-icon">
                  <label
                    class="form-check-label custom-option-content"
                    for="account_name"
                  >
                    <span class="custom-option-body">
                      <i class="ti ti-user"></i>
                      <span class="custom-option-title">
                        {{ $t("online.account_name") }}
                      </span>
                    </span>
                    <input
                      class="form-check-input"
                      type="checkbox"
                      v-model="columns.account_name.enabled"
                      @change="updateColumns"
                      id="account_name"
                    />
                  </label>
                </div>
              </div>

              <div class="col-xxl-3 col-md-4 col-6 mb-5">
                <div class="form-check custom-option custom-option-icon">
                  <label
                    class="form-check-label custom-option-content"
                    for="mac"
                  >
                    <span class="custom-option-body">
                      <i class="ti ti-barcode"></i>
                      <span class="custom-option-title">
                        {{ $t("online.mac_address") }}
                      </span>
                    </span>
                    <input
                      class="form-check-input"
                      type="checkbox"
                      dir="ltr"
                      v-model="columns.mac.enabled"
                      @change="updateColumns"
                      id="mac"
                    />
                  </label>
                </div>
              </div>

              <div class="col-xxl-3 col-md-4 col-6 mb-5">
                <div class="form-check custom-option custom-option-icon">
                  <label
                    class="form-check-label custom-option-content"
                    for="ip"
                  >
                    <span class="custom-option-body">
                      <i class="ti ti-world-www"></i>
                      <span class="custom-option-title">
                        {{ $t("online.ip_address") }}
                      </span>
                    </span>
                    <input
                      class="form-check-input"
                      type="checkbox"
                      v-model="columns.ip.enabled"
                      @change="updateColumns"
                      id="ip"
                    />
                  </label>
                </div>
              </div>

              <div class="col-xxl-3 col-md-4 col-6 mb-5">
                <div class="form-check custom-option custom-option-icon">
                  <label
                    class="form-check-label custom-option-content"
                    for="network"
                  >
                    <span class="custom-option-body">
                      <i class="ti ti-topology-star"></i>
                      <span class="custom-option-title">
                        {{ $t("online.network") }}
                      </span>
                    </span>
                    <input
                      class="form-check-input"
                      type="checkbox"
                      v-model="columns.nas_name.enabled"
                      @change="updateColumns"
                      id="network"
                    />
                  </label>
                </div>
              </div>

              <div class="col-xxl-3 col-md-4 col-6 mb-5">
                <div class="form-check custom-option custom-option-icon">
                  <label
                    class="form-check-label custom-option-content"
                    for="interface"
                  >
                    <span class="custom-option-body">
                      <i class="ti ti-network"></i>
                      <span class="custom-option-title">
                        {{ $t("online.interface") }}
                      </span>
                    </span>
                    <input
                      class="form-check-input"
                      type="checkbox"
                      v-model="columns.interface.enabled"
                      @change="updateColumns"
                      id="interface"
                    />
                  </label>
                </div>
              </div>

              <div class="col-xxl-3 col-md-4 col-6 mb-5">
                <div class="form-check custom-option custom-option-icon">
                  <label
                    class="form-check-label custom-option-content"
                    for="from"
                  >
                    <span class="custom-option-body">
                      <i class="ti ti-network"></i>
                      <span class="custom-option-title">
                        {{ $t("online.from") }}
                      </span>
                    </span>
                    <input
                      class="form-check-input"
                      type="checkbox"
                      v-model="columns.from.enabled"
                      @change="updateColumns"
                      id="from"
                    />
                  </label>
                </div>
              </div>

              <div class="col-xxl-3 col-md-4 col-6 mb-5">
                <div class="form-check custom-option custom-option-icon">
                  <label
                    class="form-check-label custom-option-content"
                    for="protocol"
                  >
                    <span class="custom-option-body">
                      <i class="ti ti-network"></i>
                      <span class="custom-option-title">
                        {{ $t("online.protocol") }}
                      </span>
                    </span>
                    <input
                      class="form-check-input"
                      type="checkbox"
                      v-model="columns.framed_protocol.enabled"
                      @change="updateColumns"
                      id="protocol"
                    />
                  </label>
                </div>
              </div>

              <div class="col-xxl-3 col-md-4 col-6 mb-5">
                <div class="form-check custom-option custom-option-icon">
                  <label
                    class="form-check-label custom-option-content"
                    for="traffic_used"
                  >
                    <span class="custom-option-body">
                      <i class="ti ti-chart-bar"></i>
                      <span class="custom-option-title">
                        {{ $t("online.traffic_used") }}
                      </span>
                    </span>
                    <input
                      class="form-check-input"
                      type="checkbox"
                      v-model="columns.traffic.enabled"
                      @change="updateColumns"
                      id="traffic_used"
                    />
                  </label>
                </div>
              </div>

              <div class="col-xxl-3 col-md-4 col-6 mb-5">
                <div class="form-check custom-option custom-option-icon">
                  <label
                    class="form-check-label custom-option-content"
                    for="sessionDuration"
                  >
                    <span class="custom-option-body">
                      <i class="ti ti-clock-hour-3"></i>
                      <span class="custom-option-title">
                        {{ $t("online.session_duration") }}
                      </span>
                    </span>
                    <input
                      class="form-check-input"
                      type="checkbox"
                      v-model="columns.uptime_seconds.enabled"
                      @change="updateColumns"
                      id="sessionDuration"
                    />
                  </label>
                </div>
              </div>
              <div class="col-xxl-3 col-md-4 col-6 mb-5">
                <div class="form-check custom-option custom-option-icon">
                  <label
                    class="form-check-label custom-option-content"
                    for="connectTime"
                  >
                    <span class="custom-option-body">
                      <i class="ti ti-login"></i>
                      <span class="custom-option-title">
                        {{ $t("online.connect_time") }}
                      </span>
                    </span>
                    <input
                      class="form-check-input"
                      type="checkbox"
                      v-model="columns.uptime_seconds.enabled"
                      @change="updateColumns"
                      id="connectTime"
                    />
                  </label>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="p-6 flex-grow-1 container-p-y">
    <div class="card">
      <div class="card-datatable">
        <div class="dataTables_wrapper dt-bootstrap5 no-footer">
          <div class="row mx-1" bis_skin_checked="1">
            <!-- <div
              class="col-12 col-md-4 d-flex align-items-center justify-content-center justify-content-md-start gap-2 mt-6 mt-md-0 mt-lg-0 mt-xl-0 mt-xxl-0"
              bis_skin_checked="1"
            >
              <div
                class="dt-action-buttons text-xl-end text-lg-start text-md-end text-start"
                bis_skin_checked="1"
              >
                <div
                  class="dt-buttons btn-group flex-wrap"
                  bis_skin_checked="1"
                >
                  <button
                    class="btn btn-danger waves-effect waves-light"
                    @click="confirmDeleteAllSessions"
                  >
                    <span>
                      <i class="ti ti-trash ti-xs me-2"></i>
                      <span>{{ $t("online.delete_all_sessions") }}</span>
                    </span>
                  </button>
                </div>
              </div>
            </div> -->

            <div
              class="col-12 col-md-12 d-flex align-items-center justify-content-end flex-column flex-md-row pe-5 gap-2 gap-md-4 mt-4  mt-md-0"
              bis_skin_checked="1"
            >
              <div
                class="dt-action-buttons text-xl-end text-lg-start text-md-end text-start"
                bis_skin_checked="1"
              >
                <div class="btn-group" id="dropdown-icon-demo">
                  <button
                    v-if="hasPrivilege('reports_print')"
                    :disabled:="!this.$store.getters.settings.license.active"
                    type="button"
                    class="btn btn-info dropdown-toggle"
                    data-bs-toggle="dropdown"
                    aria-expanded="false"
                  >
                    <i class="ti ti-upload ti-xs me-2"></i>
                    {{ $t("control.export") }}
                  </button>
                  <ul class="dropdown-menu">
                    <li>
                      <a
                        href="javascript:void(0);"
                        @click.prevent="print_table('online_table')"
                        class="dropdown-item d-flex align-items-center"
                        ><i class="ti ti-printer me-2"></i
                        >{{ $t("control.print") }}</a
                      >
                    </li>
                    <li>
                      <a
                        @click.prevent="export_csv('online_table', 'online')"
                        href="javascript:void(0);"
                        class="dropdown-item d-flex align-items-center"
                        ><i class="ti ti-file me-2"></i
                        >{{ $t("control.csv") }}</a
                      >
                    </li>
                    <li>
                      <a
                        href="javascript:void(0);"
                        @click.prevent="print_table('online_table')"
                        class="dropdown-item d-flex align-items-center"
                        ><i class="ti ti-file-text me-2"></i
                        >{{ $t("control.pdf") }}</a
                      >
                    </li>
                  </ul>
                </div>
              </div>

              <div
                id="DataTables_Table_0_filter"
                class="dataTables_filter"
                bis_skin_checked="1"
              >
                <label>
                  <input
                    type="search"
                    class="form-control"
                    @change="applyFilters"
                    v-if="hasPrivilege('accounts_view_search_online')"
                    v-model="filters.search_query"
                    :placeholder="$t('control.search')"
                    aria-controls="DataTables_Table_0"
                  />
                </label>
              </div>
            </div>
          </div>

          <div class="row mx-1 mt-n6" bis_skin_checked="1">
            <div
              class="col-12 col-md-6 d-flex align-items-center justify-content-center justify-content-md-start gap-2"
              bis_skin_checked="1"
            >
              <div
                class="dataTables_length"
                id="DataTables_Table_0_length"
                bis_skin_checked="1"
              >
                <label
                  >{{ $t("control.show") }}
                  <select
                    name="DataTables_Table_0_length"
                    aria-controls="DataTables_Table_0"
                    class="form-select"
                    v-model="filters.rows"
                    @change="applyFilters"
                  >
                    <option value="10">10</option>
                    <option value="25">25</option>
                    <option value="50">50</option>
                    <option value="100">100</option>
                    <option value="9999999">{{
                      $t("control.rows_all")
                    }}</option>
                  </select>
                </label>
              </div>
              <div
                class="dt-action-buttons text-xl-end text-lg-start text-md-end text-start"
                bis_skin_checked="1"
              >
                <div
                  class="dt-buttons btn-group flex-wrap"
                  bis_skin_checked="1"
                >
                  <button
                    data-bs-toggle="modal"
                    data-bs-target="#sessions-columns"
                    class="btn btn-secondary  waves-effect waves-light"
                    tabindex="0"
                    aria-controls="DataTables_Table_0"
                    type="button"
                  >
                    <span>
                      <i class="ti ti-scan-eye ti-s me-md-2"></i>
                      <span class="d-md-inline-block d-none">{{
                        $t("control.columns_visible")
                      }}</span>
                    </span>
                  </button>
                </div>
              </div>
              <div>
                <button
                  @click.prevent="disconnectSessions"
                  class="btn btn-success btn-sm"
                >
                  {{ $t("online.clear_all") }}
                </button>
              </div>
            </div>

            <div
              class="col-12 col-md-6 d-flex align-items-center justify-content-end flex-column flex-md-row pe-5 gap-2 gap-md-4 mt-n2 mb-6 mb-md-0 mt-md-0"
              bis_skin_checked="1"
            >
              <div
                class="dt-action-buttons text-xl-end text-lg-start text-md-end text-start"
                bis_skin_checked="1"
              >
                <div
                  class="dt-buttons btn-group flex-wrap"
                  bis_skin_checked="1"
                >
                  <button
                    :class="{
                      'btn-primary': autoUpdate,
                      'btn-secondary': !autoUpdate,
                    }"
                    @click.prevent="toggleAutoUpdate"
                    class="btn waves-effect waves-light"
                    tabindex="0"
                    aria-controls="DataTables_Table_0"
                    type="button"
                  >
                    <span>
                      <i class="ti ti-refresh ti-s me-2"></i>
                      <span class=" ">{{ $t("control.auto_update") }}</span>
                    </span>
                  </button>
                </div>
              </div>
              <div
                class="dt-action-buttons text-xl-end text-lg-start text-md-end text-start"
                bis_skin_checked="1"
              >
                <div
                  class="dt-buttons btn-group flex-wrap"
                  bis_skin_checked="1"
                >
                  <button
                    :class="{
                      'btn-primary': filters.save,
                      'btn-secondary': !filters.save,
                    }"
                    @click.prevent="toggleSaveFilters"
                    class="btn waves-effect waves-light"
                    tabindex="0"
                    aria-controls="DataTables_Table_0"
                    type="button"
                  >
                    <span>
                      <i class="ti ti-filter-check ti-s me-2"></i>
                      <span class=" ">{{ $t("control.save_filters") }}</span>
                    </span>
                  </button>
                </div>
              </div>
            </div>
          </div>

          <div class="dataTables_scroll" bis_skin_checked="1">
            <div
              class="dataTables_scrollBody table-container"
              bis_skin_checked="1"
              style="position: relative; overflow: auto; width: 100%; height: 480px;"
            >
              <table
                class="dt-scrollableTable table"
                id="online_table"
                aria-describedby="DataTables_Table_0_info"
              >
                <thead
                  style="background-color: var(--bs-card-bg);"
                  class="sticky top-0 z-50"
                >
                  <tr class="text-nowrap">
                    <th>
                      <div class="dropdown" v-if="selection_array.length > 1">
                        <button
                          type="button"
                          class="btn p-0 dropdown-toggle hide-arrow"
                          data-bs-toggle="dropdown"
                        >
                          <i class="ti ti-dots-vertical"></i>
                        </button>
                        <ul class="dropdown-menu">
                          <li v-if="hasPrivilege('sessions_disconnect')">
                            <button
                              @click="groupDisconnect"
                              class="dropdown-item text-warning"
                              href="#"
                            >
                              <i class="ti ti-shield-off me-2"></i
                              >{{ $t("actions.disconnect") }}
                            </button>
                          </li>
                        </ul>
                      </div>
                    </th>
                    <th>
                      <input
                        class="form-check-input"
                        type="checkbox"
                        :value="allSelected"
                        @click="checkAll"
                      />
                    </th>
                    <th>#</th>
                    <th v-if="columns.username.enabled">
                      {{ $t("online.username") }}
                    </th>
                    <th v-if="columns.account_name.enabled">
                      {{ $t("online.account_name") }}
                    </th>
                    <th v-if="columns.mac.enabled">
                      {{ $t("online.mac_address") }}
                    </th>
                    <th v-if="columns.ip.enabled">
                      {{ $t("online.ip_address") }}
                    </th>
                    <th v-if="columns.nas_name.enabled">
                      {{ $t("online.network") }}
                    </th>
                    <th v-if="columns.interface.enabled">
                      {{ $t("online.interface") }}
                    </th>
                    <th v-if="columns.framed_protocol.enabled">
                      {{ $t("online.protocol") }}
                    </th>
                    <th v-if="columns.traffic.enabled">
                      {{ $t("online.traffic_used") }}
                    </th>
                    <th v-if="columns.uptime_seconds.enabled">
                      {{ $t("online.session_duration") }}
                    </th>
                    <th v-if="columns.start_date.enabled">
                      {{ $t("online.connect_time") }}
                    </th>
                  </tr>
                  <tr v-if="hasPrivilege('accounts_view_search_online')">
                    <th></th>
                    <th></th>
                    <th></th>
                    <th v-if="columns.username.enabled">
                      <input
                        type="text"
                        v-model="filters.username_query"
                        @change="applyFilters"
                        class="form-control form-control-sm"
                        :placeholder="`${$t('control.search')}`"
                      />
                    </th>
                    <th v-if="columns.account_name.enabled">
                      <input
                        type="text"
                        v-model="filters.account_name"
                        @change="applyFilters"
                        class="form-control form-control-sm"
                        :placeholder="`${$t('control.search')}`"
                      />
                    </th>
                    <th v-if="columns.mac.enabled">
                      <input
                        type="text"
                        v-model="filters.mac"
                        @change="applyFilters"
                        class="form-control form-control-sm"
                        :placeholder="`${$t('control.search')}`"
                      />
                    </th>
                    <th v-if="columns.ip.enabled">
                      <input
                        type="text"
                        v-model="filters.ip"
                        @change="applyFilters"
                        class="form-control form-control-sm"
                        :placeholder="`${$t('control.search')}`"
                      />
                    </th>
                    <th v-if="columns.nas_name.enabled">
                      <input
                        type="text"
                        v-model="filters.nas_name"
                        @change="applyFilters"
                        class="form-control form-control-sm"
                        :placeholder="`${$t('control.search')}`"
                      />
                    </th>
                    <th v-if="columns.interface.enabled">
                      <input
                        type="text"
                        v-model="filters.interface"
                        @change="applyFilters"
                        class="form-control form-control-sm"
                        :placeholder="`${$t('control.search')}`"
                      />
                    </th>
                    <th v-if="columns.framed_protocol.enabled">
                      <input
                        type="text"
                        v-model="filters.framed_protocol"
                        @change="applyFilters"
                        class="form-control form-control-sm"
                        :placeholder="`${$t('control.search')}`"
                      />
                    </th>
                    <th v-if="columns.traffic.enabled"></th>
                    <th v-if="columns.uptime_seconds.enabled"></th>

                    <th v-if="columns.start_date.enabled">
                      <input type="date" class="form-control form-control-sm" />
                    </th>
                  </tr>
                </thead>
                <tbody v-if="loading" class="table-border-bottom-0 ">
                  <tr v-for="(item, index) in 10" :key="index">
                    <th>
                      <p class="placeholder-glow">
                        <span class="placeholder col-12"></span>
                      </p>
                    </th>
                    <th>
                      <p class="placeholder-glow">
                        <span class="placeholder col-12"></span>
                      </p>
                    </th>
                    <th>
                      <p class="placeholder-glow">
                        <span class="placeholder col-12"></span>
                      </p>
                    </th>
                    <th
                      v-for="(item, index) in Object.values(columns).filter(
                        (col) => col?.enabled === true,
                      ).length"
                      :key="index"
                    >
                      <p class="placeholder-glow">
                        <span class="placeholder col-12"></span>
                      </p>
                    </th>
                  </tr>
                </tbody>
                <tbody class="table-border-bottom-0 " v-if="!loading">
                  <tr v-for="(session, index) in dataList" :key="session.id">
                    <td>
                      <div class="dropdown" v-if="selection_array.length <= 1">
                        <button
                          type="button"
                          class="btn p-0 dropdown-toggle hide-arrow"
                          data-bs-toggle="dropdown"
                        >
                          <i class="ti ti-dots-vertical"></i>
                        </button>
                        <ul class="dropdown-menu">
                          <li v-if="hasPrivilege('sessions_disconnect')">
                            <button
                              @click="disconnectData(session)"
                              class="dropdown-item text-warning"
                            >
                              <i class="ti ti-wifi-off me-2"></i
                              >{{ $t("actions.disconnect") }}
                            </button>
                          </li>
                        </ul>
                      </div>
                    </td>
                    <td>
                      <input
                        class="form-check-input"
                        type="checkbox"
                        v-model="session.selected"
                        @click="selectData(session)"
                      />
                    </td>

                    <td>{{ session.id }}</td>
                    <td v-if="columns.username.enabled">
                      <a
                        v-if="session.account_id"
                        @click.prevent="
                          $router.push(`/accounts/${session.account_id}`)
                        "
                        :href="`/accounts/${session.account_id}`"
                      >
                        {{ session.username }}
                      </a>
                      <a
                        v-if="session.card_id"
                        @click.prevent="
                          $router.push(`/cards?username=${session.username}`)
                        "
                        :href="`/cards?username=${session.username}`"
                      >
                        {{ session.username }}
                      </a>
                    </td>
                    <td v-if="columns.account_name.enabled">
                      {{ session.account_name }}
                    </td>
                    <td v-if="columns.mac.enabled" dir="ltr">
                      {{ session.mac }}
                    </td>
                    <td v-if="columns.ip.enabled">
                      <a
                        :href="`http://${session.ip}`"
                        target="_blank"
                        @click.prevent="openTab(`http://${session.ip}`)"
                        >{{ session.ip }}</a
                      >
                    </td>
                    <td v-if="columns.nas_name.enabled">
                      {{ session.nas_name }}
                    </td>
                    <td v-if="columns.interface.enabled">
                      {{ session.interface }}
                    </td>
                    <td v-if="columns.framed_protocol.enabled">
                      {{ session.framed_protocol }}
                    </td>
                    <td v-if="columns.traffic.enabled">
                      <span class="badge bg-label-info mb-2 me-1">{{
                        formatTraffic(session.download_bytes)
                      }}</span>
                      <span class="badge bg-label-danger me-1">{{
                        formatTraffic(session.upload_bytes)
                      }}</span>
                    </td>
                    <td v-if="columns.uptime_seconds.enabled">
                      <span class="badge bg-label-warning">{{
                        formatTime(session.uptime_seconds)
                      }}</span>
                    </td>
                    <td v-if="columns.start_date.enabled">
                      {{ formatDate(session.start_date) }}
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>

          <div class="row mx-1" bis_skin_checked="1">
            <div class="col-sm-12 col-md-6" bis_skin_checked="1">
              <div
                class="dataTables_info"
                id="DataTables_Table_0_info"
                role="status"
                aria-live="polite"
                bis_skin_checked="1"
              >
                {{
                  $t("control.pagination", {
                    from: meta.from,
                    to: meta.to,
                    total: meta.total,
                  })
                }}
              </div>
            </div>

            <div class="col-sm-12 col-md-6" bis_skin_checked="1">
              <div
                class="dataTables_paginate paging_simple_numbers"
                id="DataTables_Table_0_paginate"
                bis_skin_checked="1"
              >
                <ul class="pagination">
                  <li
                    :class="{ disabled: filters.page < 2 }"
                    class="paginate_button page-item previous"
                    id="DataTables_Table_0_previous"
                  >
                    <a
                      @click.prevent="
                        filters.page = filters.page - 1;
                        applyFilters;
                      "
                      aria-controls="DataTables_Table_0"
                      aria-disabled="true"
                      role="link"
                      data-dt-idx="previous"
                      tabindex="-1"
                      class="page-link"
                    >
                      <i class="ti ti-chevron-left ti-sm"></i>
                    </a>
                  </li>
                  <li
                    class="paginate_button page-item"
                    :class="{
                      active: link.label == filters.page,
                      disabled: link.url == null,
                    }"
                    v-for="(link, index) in meta.links"
                    :key="index"
                  >
                    <a
                      v-if="index != 0 && index < meta.links.length - 1"
                      @click.prevent="
                        filters.page = link.label;
                        applyFilters();
                      "
                      href="#"
                      aria-controls="DataTables_Table_0"
                      role="link"
                      aria-current="page"
                      data-dt-idx="0"
                      tabindex="0"
                      class="page-link"
                      >{{ link.label }}</a
                    >
                  </li>
                  <li
                    :class="{
                      disabled: meta.current_page == meta.last_page,
                    }"
                    class="paginate_button page-item next"
                    id="DataTables_Table_0_next"
                  >
                    <a
                      href="#"
                      aria-controls="DataTables_Table_0"
                      role="link"
                      data-dt-idx="next"
                      tabindex="0"
                      class="page-link"
                    >
                      <i class="ti ti-chevron-right ti-sm"></i>
                    </a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import axios from "axios";
import moment from "moment";
import { mapGetters } from "vuex";
import {
  export_csv,
  export_pdf,
  hasPrivilege,
  print_table,
} from "../global_constants.js";
export default {
  name: "OnlineSessions",
  computed: {
    ...mapGetters(["user"]),
  },
  data() {
    return {
      dataList: null,
      meta: { last_page: 0 },
      selectedData: null,
      showCardDetails: false,
      showAccountDetails: false,
      showProfileDetails: false,
      showDelete: false,
      showContext: false,
      showDisconnect: false,
      loading: true,
      showFilters: false,
      fullList: false,
      username: null,
      filters: {
        rows: 50,
        page: "",
        save: false,
        username_query: "",
        account_name: "",
        ip: "",
        mac: "",
        nas_name: "",
        type: "",
        traffic: "",
        uptime_seconds: "",
        framed_protocol: "",
        interface: "",
        from: "",
        start_date: "",
        search_query: null,
      },
      checkedBox: true,
      allSelected: false,
      showColumnsSelect: false,
      showTruncate: false,
      rangeDate: null,
      format: (date) => {
        const day = date[0].getDate();
        const month = date[0].getMonth() + 1;
        const year = date[0].getFullYear();
        const day2 = date[1] != null ? date[1].getDate() : "";
        const month2 = date[1] != null ? date[1].getMonth() + 1 : "";
        const year2 = date[1] != null ? date[1].getFullYear() : "";

        return `${day}-${month}-${year} -> ${day2}-${month2}-${year2}`;
      },
      columns: {
        ip: { name: this.$t("online.ip"), enabled: true, sort: false },
        mac: {
          name: this.$t("online.mac_address"),
          enabled: true,
          sort: false,
        },
        username: {
          name: this.$t("online.username"),
          enabled: true,
          sort: false,
        },
        account_name: {
          name: this.$t("online.account_name"),
          enabled: true,
          sort: false,
        },
        nas_name: {
          name: this.$t("online.nas_name"),
          enabled: true,
          sort: false,
        },
        interface: {
          name: this.$t("online.interface"),
          enabled: true,
          sort: false,
        },
        from: {
          name: this.$t("online.from"),
          enabled: false,
          sort: false,
        },
        framed_protocol: {
          name: this.$t("online.protocol"),
          enabled: false,
          sort: false,
        },
        traffic: {
          name: this.$t("online.traffic_used"),
          enabled: true,
          sort: false,
        },
        uptime_seconds: {
          name: this.$t("online.uptime"),
          enabled: true,
          sort: false,
        },
        start_date: {
          name: this.$t("online.start_date"),
          enabled: true,
          sort: false,
        },
      },
      autoUpdate: false,
      selection_array: [],
      debounce: null,
      loading_overlay: false,
      upload_sum: 0,
      download_sum: 0,
      uptime_sum: 0,
      pdfOptions: {
        margin: 5,
        image: {
          type: "jpeg",
          quality: 1,
        },
        html2canvas: { scale: 1, dpi: 96, letterRendering: true },
        jsPDF: {
          unit: "mm",
          format: "a4",
          orientation: "p",
        },
      },
      exportFilename: "my-custom-file.pdf",
    };
  },
  async created() {
    this.username = this.$route.params.username;
    this.prepareFilters();
    this.applyFilters();
    this.prepareColumns();
  },
  methods: {
    hasPrivilege(privilege) {
      return hasPrivilege(this.user, privilege);
    },
    async fetchData() {
      if (this.filters.rows > 0 || this.filters.page > 0) {
        this.fetchDataPortion(this.filters.rows, this.filters.page);
        this.selection_array = [];
        return;
      }
      const response = await axios.get("online");
      this.dataList = response.data.data;
      this.meta = response.data.meta;
      this.loading = false;
    },
    prepareFilters() {
      var filters = localStorage.getItem("online_filters");
      if (filters != null) {
        filters = JSON.parse(filters);
        if (filters.save) this.filters = filters;
        else this.filters.rows = filters.rows;
      }
    },
    prepareColumns() {
      var cols = localStorage.getItem("online_columns");
      if (cols != null) {
        cols = JSON.parse(cols);
        this.columns = {
          ip: {
            name: this.$t("online.ip"),
            enabled: cols[0].enabled,
            sort: false,
          },
          username: {
            name: this.$t("online.username"),
            enabled: cols[1].enabled,
            sort: false,
          },
          account_name: {
            name: this.$t("online.account_name"),
            enabled: cols[2].enabled,
            sort: false,
          },
          mac: {
            name: this.$t("online.mac_address"),
            enabled: cols[3].enabled,
            sort: false,
          },
          nas_name: {
            name: this.$t("online.nas_name"),
            enabled: cols[4].enabled,
            sort: false,
          },
          framed_protocol: {
            name: this.$t("online.protocol"),
            enabled: cols[5].enabled,
            sort: false,
          },
          interface: {
            name: this.$t("online.interface"),
            enabled: cols[6].enabled,
            sort: false,
          },
          from: {
            name: this.$t("online.from"),
            enabled: cols[7].enabled,
            sort: false,
          },
          traffic: {
            name: this.$t("online.traffic_used"),
            enabled: cols[8].enabled,
            sort: false,
          },
          uptime_seconds: {
            name: this.$t("online.session_duration"),
            enabled: cols[9].enabled,
            sort: false,
          },

          start_date: {
            name: this.$t("online.connect_time"),
            enabled: cols[10].enabled,
            sort: false,
          },
        };
      }
    },
    async applyFilters() {
      this.loading = true;

      var requestString = `online?filters=1&status=online`;
      if (this.username != null) requestString += `&username=${this.username}`;
      if (this.filters.page != "")
        requestString += `&page=${this.filters.page}`;
      if (this.filters.rows != "")
        requestString += `&rows=${this.filters.rows}`;
      if (this.filters.mac != "") requestString += `&mac=${this.filters.mac}`;
      if (this.filters.ip != "") requestString += `&ip=${this.filters.ip}`;
      if (this.filters.nas_name != "")
        requestString += `&nas_name=${this.filters.nas_name}`;
      if (this.filters.framed_protocol != "")
        requestString += `&service=${this.filters.framed_protocol}`;
      if (this.filters.from != "")
        requestString += `&from=${this.filters.from}`;
      if (this.filters.interface != "")
        requestString += `&interface=${this.filters.interface}`;
      if (this.filters.search_query != null)
        requestString += `&search_query=${this.filters.search_query}`;
      if (this.filters.start_date != "")
        requestString += `&start_date=${this.filters.start_date}`;
      if (this.filters.username_query != "")
        requestString += `&username_query=${this.filters.username_query}`;
      if (this.filters.account_name != "")
        requestString += `&account_name=${this.filters.account_name}`;

      if (this.rangeDate != null) {
        if (this.rangeDate[0] != null)
          requestString += `&range_start=${moment(this.rangeDate[0]).format(
            "yyyy-MM-DD",
          )}`;
        if (this.rangeDate[1] != null)
          requestString += `&range_stop=${moment(this.rangeDate[1]).format(
            "yyyy-MM-DD",
          )}`;
      }
      if (this.sort_col)
        requestString += `&order_by=${this.sort_col}&order_dir=${this.sort_dir}`;

      const response = await axios.get(requestString);
      this.dataList = response.data.data;
      if (this.filters.save)
        localStorage.setItem("online_filters", JSON.stringify(this.filters));
      if (this.dataList.length < 1 && this.filters.page != 1) {
        this.filters.page = 1;
        this.applyFilters();
      }
      if (this.sort_col) {
        if (this.sort_dir == "ASC") {
          this.dataList.sort((a, b) =>
            a[this.sort_col] > b[this.sort_col]
              ? 1
              : b[this.sort_col] > a[this.sort_col]
              ? -1
              : 0,
          );
        } else {
          this.dataList.sort((a, b) =>
            a[this.sort_col] < b[this.sort_col]
              ? 1
              : b[this.sort_col] < a[this.sort_col]
              ? -1
              : 0,
          );
        }
      }
      this.meta = response.data.meta;
      this.upload_sum = 0;
      this.download_sum = 0;
      this.uptime_sum = 0;
      this.dataList.forEach((element) => {
        this.download_sum += element.download_mb;
        this.upload_sum += element.upload_mb;
        this.uptime_sum += element.uptime_seconds;
      });
      this.loading = false;
      // clearTimeout(this.debounce);
      // this.debounce = setTimeout(async () => {
      //   const response = await axios.get(requestString);
      //   this.dataList = response.data.data;
      //   if (this.filters.save)
      //     localStorage.setItem("online_filters", JSON.stringify(this.filters));
      //   if (this.dataList.length < 1 && this.filters.page != 1) {
      //     this.filters.page = 1;
      //     this.applyFilters();
      //   }
      //   if (this.sort_col) {
      //     if (this.sort_dir == "ASC") {
      //       this.dataList.sort((a, b) =>
      //         a[this.sort_col] > b[this.sort_col]
      //           ? 1
      //           : b[this.sort_col] > a[this.sort_col]
      //           ? -1
      //           : 0
      //       );
      //     } else {
      //       this.dataList.sort((a, b) =>
      //         a[this.sort_col] < b[this.sort_col]
      //           ? 1
      //           : b[this.sort_col] < a[this.sort_col]
      //           ? -1
      //           : 0
      //       );
      //     }
      //   }
      //   this.meta = response.data.meta;
      //   this.upload_sum = 0;
      //   this.download_sum = 0;
      //   this.uptime_sum = 0;
      //   this.dataList.forEach((element) => {
      //     this.download_sum += element.download_mb;
      //     this.upload_sum += element.upload_mb;
      //     this.uptime_sum += element.uptime_seconds;
      //   });
      //   this.loading = false;
      // }, 1000);
    },
    async disconnectData(session) {
      this.$swal({
        title: this.$t("control.are_you_sure"),
        text:
          this.$t("accounts.this_will_disconnect_the_user_from_the_internet") +
          " " +
          session.ip,
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: this.$t("accounts.yes_disconnect"),
        cancelButtonText: this.$t("control.no"),
        reverseButtons: true,
        backdrop: true,
        buttonsStyling: false,
        customClass: {
          confirmButton: "btn btn-label-danger",
          cancelButton: "btn btn-label-secondary",
        },
      }).then(async (result) => {
        if (result.isConfirmed) {
          try {
            const response = await axios.post(
              `online/disconnect/${session.id}`,
            );
            if (response.status == 200) {
              this.selection_array = [];
              this.applyFilters();
            }
            this.$swal({
              title: this.$t("control.disconnect"),
              text: this.$t(
                "accounts.the_user_has_been_disconnected_from_the_internet",
              ),
              icon: "success",
              timer: 1500,
              showConfirmButton: false,
              backdrop: true,
            });
          } catch (error) {
            this.$swal({
              title: this.$t("control.error"),
              text:
                error.response?.data?.message ||
                this.$t("control.some_thing_went_wrong_please_try_again"),
              icon: "error",
              confirmButtonText: this.$t("control.ok"),
              backdrop: true,
            });
          }
        }
      });
    },
    async groupDisconnect() {
      this.$swal({
        title: this.$t("control.are_you_sure"),
        text: this.$t(
          "sessions.this_will_disconnect_selected_sessions_from_the_internet",
        ),
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: this.$t("accounts.yes_disconnect"),
        cancelButtonText: this.$t("control.no"),
        reverseButtons: true,
        backdrop: true,
        buttonsStyling: false,
        customClass: {
          confirmButton: "btn btn-label-danger",
          cancelButton: "btn btn-label-secondary",
        },
      }).then(async (result) => {
        if (result.isConfirmed) {
          try {
            const response = await axios.post(`online/disconnect/group`, {
              sessions: this.selection_array,
            });
            if (response.status == 200) {
              this.selection_array = [];
              this.applyFilters();
            }
            this.$swal({
              title: this.$t("control.disconnect"),
              text: this.$t(
                "accounts.the_user_has_been_disconnected_from_the_internet",
              ),
              icon: "success",
              timer: 1500,
              showConfirmButton: false,
              backdrop: true,
            });
          } catch (error) {
            this.$swal({
              title: this.$t("control.error"),
              text:
                error.response?.data?.message ||
                this.$t("control.some_thing_went_wrong_please_try_again"),
              icon: "error",
              confirmButtonText: this.$t("control.ok"),
              backdrop: true,
            });
          }
        }
      });
    },
    async disconnectSessions() {
      this.$swal({
        title: this.$t("control.are_you_sure"),
        text: this.$t(
          "online.this_will_clear_all_online_sessions_from_radius_only",
        ),
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: this.$t("online.yes_clear"),
        cancelButtonText: this.$t("control.no"),
        reverseButtons: true,
        backdrop: true,
        buttonsStyling: false,
        customClass: {
          confirmButton: "btn btn-label-danger",
          cancelButton: "btn btn-label-secondary",
        },
      }).then(async (result) => {
        if (result.isConfirmed) {
          try {
            const response = await axios.post(`online/clear/all`, {
              sessions: this.selection_array,
            });
            if (response.status == 200) {
              this.selection_array = [];
              this.applyFilters();
            }
            this.$swal({
              title: this.$t("control.disconnect"),
              text: this.$t("online.online_sessions_has_been_cleared"),
              icon: "success",
              timer: 1500,
              showConfirmButton: false,
              backdrop: true,
            });
          } catch (error) {
            this.$swal({
              title: this.$t("control.error"),
              text:
                error.response?.data?.message ||
                this.$t("control.some_thing_went_wrong_please_try_again"),
              icon: "error",
              confirmButtonText: this.$t("control.ok"),
              backdrop: true,
            });
          }
        }
      });
    },
    async fetchDataPortion(rows, currentPage) {
      this.filters.rows = rows;
      this.filters.page = currentPage;
      this.applyFilters();
    },
    formatDate(date) {
      return moment(date).format("YYYY-MM-DD hh:mm a");
    },
    openContextMenu(e, data) {
      this.selectedData = data;
      this.$refs.menu.open(e);
    },
    checkAll() {
      if (this.allSelected) {
        this.selection_array = [];
        this.dataList.forEach((element) => {
          element.selected = false;
        });
        this.allSelected = false;
      } else {
        this.selection_array = [];
        this.dataList.forEach((element) => {
          element.selected = true;
          this.selection_array.push(element);
        });
        this.allSelected = true;
      }
    },
    selectData(data) {
      if (data.selected == false) {
        data.selected = true;
        this.selection_array.push(data);
      } else {
        data.selected = false;
        this.selection_array.splice(this.selection_array.indexOf(data), 1);
      }
    },
    async toggleAutoUpdate() {
      this.autoUpdate = !this.autoUpdate;
      while (this.autoUpdate) {
        this.applyFilters();
        await new Promise((r) => setTimeout(r, 30000));
      }
    },
    calculateTime(seconds) {
      if (seconds < 59) {
        return seconds + " " + this.$t("control.seconds");
      } else if (seconds >= 60 && seconds < 3599) {
        return (
          parseFloat(seconds / 60).toFixed(0) + " " + this.$t("control.minutes")
        );
      } else if (seconds >= 3600) {
        let hours = parseInt(seconds / 3600);
        let hours_seconds = hours * 3600;
        let minutes = parseFloat((seconds - hours_seconds) / 60).toFixed(0);
        if (minutes > 1)
          return (
            this.$t("control.hours") +
            hours +
            " " +
            this.$t("control.minutes") +
            minutes
          );
        else return hours + " " + this.$t("control.hours");
      }
    },
    sort(param) {
      this.sort_col = param;
      if (param == "callingstationid") param = "mac";
      if (param == "framedipaddress") param = "ip";
      if (param == "nasipaddress") param = "nas_name";
      if (param == "nasportid") param = "interface";
      if (param == "calledstationid") param = "from";
      if (param == "acctstoptime") param = "stop_date";
      if (param == "acctstarttime") param = "start_date";
      if (param == "acctsessiontime") param = "uptime_seconds";
      if (param == "acctoutputoctet") param = "traffic";
      if (!this.columns[param].sort) {
        this.sort_dir = "ASC";
        Object.entries(this.columns).forEach(([key, val]) => {
          val.sort = false;
        });
        this.columns[param].sort = true;
      } else {
        this.sort_dir = "DESC";
        Object.entries(this.columns).forEach(([key, val]) => {
          val.sort = false;
        });
        this.columns[param].sort = false;
      }
      this.applyFilters();
    },
    sort_traffic() {
      this.sort_col = "download_mb";
      if (!this.columns.traffic.sort) {
        this.sort_dir = "ASC";
        this.dataList.sort((a, b) =>
          a.download_mb + a.upload_mb > b.download_mb + b.upload_mb
            ? 1
            : b.download_mb + b.upload_mb > a.download_mb + a.upload_mb
            ? -1
            : 0,
        );
        this.columns.traffic.sort = true;
      } else {
        this.sort_dir = "DESC";
        this.dataList.sort((a, b) =>
          a.download_mb + a.upload_mb < b.download_mb + b.upload_mb
            ? 1
            : b.download_mb + b.upload_mb < a.download_mb + a.upload_mb
            ? -1
            : 0,
        );
        this.columns.traffic.sort = false;
      }
    },
    toggleSaveFilters() {
      this.filters.save = !this.filters.save;
      localStorage.setItem("online_filters", JSON.stringify(this.filters));
    },
    printTable() {
      var divContents = document.getElementById("sessions_table").innerHTML;
      var a = window.open("", "", "height=500, width=500");
      a.document.write("<html>");
      a.document.write("<body > <h1>Div contents are <br>");
      a.document.write(divContents);
      a.document.write("</body></html>");
      a.document.close();
      a.print();
    },
    openTab(url) {
      window.open(url, "_blank");
    },
    confirmDeleteAllSessions() {
      this.$swal({
        title: "Are you sure?",
        text: "This will delete all Sessions permanently!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Yes",
        cancelButtonText: "No",
        reverseButtons: true,
        backdrop: true,
        buttonsStyling: false,
        customClass: {
          confirmButton: "btn btn-label-danger",
          cancelButton: "btn btn-label-secondary",
        },
      }).then((result) => {
        if (result.isConfirmed) {
          try {
            this.$swal({
              title: "Deleted!",
              text: "All Sessions have been deleted.",
              icon: "success",
              timer: 1500,
              showConfirmButton: false,
              backdrop: true,
            });
          } catch (error) {
            this.$swal({
              title: "Error",
              text:
                error.response?.data?.message ||
                "Something went wrong. Please try again later.",
              icon: "error",
              confirmButtonText: "OK",
              backdrop: true,
            });
          }
        } else if (result.dismiss === this.$swal.DismissReason.cancel) {
          this.$swal({
            title: "Cancelled",
            text: "The operation was cancelled.",
            icon: "error",
            timer: 1500,
            showConfirmButton: false,
            backdrop: true,
          });
        }
      });
    },
    updateColumns() {
      localStorage.setItem(
        "online_columns",
        JSON.stringify(Object.values(this.columns)),
      );
    },
    formatTraffic(octets) {
      const bytes = octets; // 1 octet = 1 byte
      const units = ["B", "KB", "MB", "GB", "TB"];
      let i = 0;
      let value = bytes;

      while (value >= 1024 && i < units.length - 1) {
        value /= 1024;
        i++;
      }

      return `${value.toFixed(1)} ${units[i]}`;
    },
    formatTime(seconds) {
      const hours = Math.floor(seconds / 3600);
      const minutes = Math.floor((seconds % 3600) / 60);

      const parts = [];
      if (hours > 0) parts.push(`${hours} h`);
      if (minutes > 0 || hours === 0) parts.push(`${minutes} m`);

      return parts.join(" ");
    },
    export_csv(table_id, file_name) {
      return export_csv(table_id, file_name);
    },
    export_pdf(table_id, file_name) {
      return export_pdf(table_id, file_name);
    },
    print_table(id) {
      print_table(id);
    },
  },
};
</script>
